import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class PasswordResetExpiredError extends CodedError {
  static get errorName() {
    return errorCodes.passwordResetExpiredError.code;
  }

  constructor(message: string = errorCodes.passwordResetExpiredError.message) {
    super(message);
    this.code = errorCodes.passwordResetExpiredError.code;
    this.message = `${message} ${errorCodes.passwordResetExpiredError.code}`;
    this.name = errorCodes.passwordResetExpiredError.name;
    this.status = errorCodes.passwordResetExpiredError.status;
  }
}
